export default "__VITE_ASSET__7343a260__"